import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-yoga': {
			// /yoga?safe&mock-data&utm_source=google&country=US&area=main-yoga&exp=web_chair_yoga_challenge_landing~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_chair_yoga_challenge_landing'),
			},
		},
	},
]

export default config
